<template>
  <div class="modal-backdrop" @click.self="$emit('close')">
    <div class="modal-content">
      <div class="modal-header">
        <h2><i class="bx bx-mail-send"></i> Send Direct Onboarding Invite</h2>
        <button class="close-btn" @click="$emit('close')">
          <i class="bx bx-x"></i>
        </button>
      </div>

      <div class="modal-body">
        <p class="text-muted mb-4">
          Send a self-onboarding link directly to a new recruit. They will be able to fill out their details and HR forms without going through the recruitment module.
        </p>
        <form @submit.prevent="sendInvite" class="hr-form">
          <div class="form-group">
            <label>Applicant Full Name <span class="text-danger">*</span></label>
            <input type="text" v-model="form.applicantName" class="form-control" required placeholder="John Doe">
          </div>
          
          <div class="form-group mt-3">
            <label>Email Address <span class="text-danger">*</span></label>
            <input type="email" v-model="form.email" class="form-control" required placeholder="john.doe@example.com">
          </div>

          <div class="form-group mt-3">
            <label>Position Title <span class="text-muted">(Optional)</span></label>
            <input type="text" v-model="form.positionTitle" class="form-control" placeholder="Software Engineer">
          </div>

          <div class="form-group mt-3">
            <label>Department <span class="text-muted">(Optional)</span></label>
            <select v-model="form.departmentName" class="form-select">
              <option value="">Select Department</option>
              <option v-for="d in departments" :key="d.id" :value="d.departmentName">
                {{ d.departmentName }}
              </option>
            </select>
          </div>

          <div class="modal-footer mt-4">
            <button type="button" class="btn btn-secondary" @click="$emit('close')" :disabled="loading">Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="loading">
              <i class="bx" :class="loading ? 'bx-loader-alt bx-spin' : 'bx-send'"></i>
              {{ loading ? 'Sending...' : 'Send Invite' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { execute, authUrl, toast } from "@/api";

export default {
  name: "DirectOnboardingModal",
  props: {
    departments: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      form: {
        applicantName: '',
        email: '',
        positionTitle: '',
        departmentName: ''
      }
    }
  },
  methods: {
    async sendInvite() {
      if (!this.form.applicantName || !this.form.email) {
        toast.error("Name and Email are required");
        return;
      }
      this.loading = true;
      try {
        const data = new FormData();
        data.append("function", "sendDirectOnboarding");
        data.append("applicantName", this.form.applicantName);
        data.append("email", this.form.email);
        data.append("positionTitle", this.form.positionTitle);
        data.append("departmentName", this.form.departmentName);

        const res = await execute(data, authUrl);
        if (res.data && res.data.success) {
          toast.success(res.data.message || "Onboarding invite sent successfully");
          this.$emit('success');
          this.$emit('close');
        } else {
          toast.error(res.data?.message || "Failed to send invite");
        }
      } catch (error) {
        console.error(error);
        toast.error("An error occurred");
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;
}
.modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  overflow: hidden;
}
.modal-header {
  padding: 1.5rem;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
}
.modal-header h2 {
  margin: 0;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #333;
}
.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
}
.modal-body {
  padding: 1.5rem;
}
.form-group {
  margin-bottom: 1rem;
}
.form-control, .form-select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 0.25rem;
}
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}
.btn {
  padding: 0.5rem 1rem;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}
.btn-primary {
  background: #0056b3;
  color: white;
}
.btn-primary:disabled {
  background: #6c757d;
  cursor: not-allowed;
}
.btn-secondary {
  background: #e9ecef;
  color: #333;
}
.text-danger { color: #dc3545; }
.text-muted { color: #6c757d; font-size: 0.9rem; }
.mt-3 { margin-top: 1rem; }
.mt-4 { margin-top: 1.5rem; }
.mb-4 { margin-bottom: 1.5rem; }
</style>
